module.exports = __webpack_public_path__ + "img/4.27f85c9d.svg";